import { AHIcon, AHIconType, AHText, Box, Circle, TouchableBox } from "arkh";
import { PropsWithChildren } from "react";

export function RadioButton(
  props: PropsWithChildren<{
    selected?: boolean;
    icon: AHIconType;
    onPress?: () => void;
  }>
) {
  const color = props.selected ? "primary" : "surface-backgroundControl";

  const borderColor = props.selected ? "primary" : "border-strong";

  return (
    <TouchableBox
      borderColor={props.selected ? "primary" : "border-strong"}
      space="medium"
      color={props.selected ? "surface-background-selected" : "surface"}
      onPress={() => {
        props.onPress?.();
      }}
      style={{
        flexDirection: "row",
        alignItems: "center",
        borderWidth: 1,
        flex: 1,

        justifyContent: "space-between",
        overflow: "hidden",
      }}
      cornerRadius="large"
    >
      <Box style={{ flexDirection: "row", alignItems: "center" }}>
        <Circle
          size="smallMedium"
          color={color}
          borderColor={borderColor}
          style={{ borderWidth: 1 }}
        >
          {props.selected ? (
            <AHIcon type="check" color="text-inverted" size="small" />
          ) : null}
        </Circle>

        <AHText spaceLeft="small" type="subtitle">
          {props.children}
        </AHText>
      </Box>
      <AHIcon
        color={props.selected ? "primary" : "washedText"}
        type={props.icon}
      />
    </TouchableBox>
  );
}
